import React, { useEffect, useState } from "react";
import { useSearchParams } from 'react-router-dom';
import { PublicidadSubNav } from "./PublicidadSubNav";
import PublicacionesList from "./PublicacionesList";
import { BottomNav } from "../BottomNav";
import FormPublicacion from "./FormPublicacion";
import SponsorsListComponent from "./SponsorsListComponnet";
import './PublicidadComponent.css';

export const PublicidadComponent = (props) => {
  const { user } = props;
  const [searchParams, setSearchParams] = useSearchParams();
  const requestedTab = searchParams.get('tab');
  const linkedPublicationId = searchParams.get('publicationId');
  const initialTab = linkedPublicationId
    ? 'publicaciones'
    : (['publicaciones', 'descuentos', 'admin'].includes(requestedTab) ? requestedTab : 'publicaciones');
  const [tab, setTab] = useState(initialTab);
  const [editing, setEditing] = useState(null);

  const isAdmin = user?.userRank === 3;
  const selectTab = (nextTab) => {
    const allowedTab = nextTab === 'admin' && !isAdmin ? 'publicaciones' : nextTab;
    setTab(allowedTab);
    setSearchParams({ tab: allowedTab });
  };

  useEffect(() => {
    if (linkedPublicationId) {
      setTab('publicaciones');
    } else if (['publicaciones', 'descuentos', 'admin'].includes(requestedTab)) {
      setTab(requestedTab === 'admin' && !isAdmin ? 'publicaciones' : requestedTab);
    }
  }, [isAdmin, linkedPublicationId, requestedTab]);

  return (
    <div className="publicidad-component">

      {/* Subnav como en encuestas */}
      <PublicidadSubNav tab={tab} setTab={selectTab} isAdmin={isAdmin} />

      <div className="content-box">
        {tab === "publicaciones" && (
          <PublicacionesList
            isAdmin={isAdmin}
            linkedPublicationId={linkedPublicationId}
            onEdit={(pub) => { setEditing(pub); selectTab("admin"); }}
          />
        )}

        {tab === "descuentos" && (
          <SponsorsListComponent I18n={props.I18n} user={props.user} />
        )}

        {tab === "admin" && isAdmin && (
          <FormPublicacion
            initialData={editing}
            onSubmit={() => {
              setEditing(null);
              selectTab("publicaciones");
            }}
          />
        )}
      </div>

      <BottomNav I18n={props.I18n} user={user} />
    </div>
  );
};
